/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Icontec (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Icontec

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import Header from "components/Headers/Header";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Container,
} from "reactstrap";

const Reportes = () => {
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <Col lg="12" md="12">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <div className="text-center text-muted mb-4">
                      <small>Descarga reportes</small>
                    </div>
                    <Form role="form">
                      <FormGroup>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-lock-circle-open" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Seleccione tipo de búsqueda"
                            type="select"
                          >
                            <option value="option1">
                              {" "}
                              Seleccione el reporte
                            </option>
                            <option value="option1">Taller</option>
                            <option value="option2">Auditor</option>
                            <option value="option3">Total</option>
                            <option value="option3">Regional</option>
                            <option value="option3">
                              Participacion del mercado
                            </option>
                            <option value="option3">Estadistica Anual</option>
                            <option value="option3">
                              Pruebas Hidrostaticas
                            </option>
                          </Input>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <Input
                          placeholder="fecha del reporte"
                          type="date"
                        ></Input>
                      </FormGroup>

                      <div className="text-center">
                        <Button className="my-4" color="primary" type="button">
                          Buscar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Reportes;
